// extracted by mini-css-extract-plugin
export default {"modal-content":"modal-content___hAt3h","container":"container___iruM_","title":"title___ClClX","description":"description___JMplH","btn-group":"btn-group___Cf3CW"};